import { useCallback, useRef } from 'react'
import { useEvent, useIsomorphicLayoutEffect } from 'react-use'
import hexRgb from 'hex-rgb'
import localFont from 'next/font/local'

const garet = localFont({
  src: [
    /* {
      path: './fonts/Garet-Book.woff2',
      weight: '300',
      style: 'normal'
    }, */
    {
      path: './fonts/Garet-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/Garet-Medium.woff2',
      weight: '500',
      style: 'normal'
    }
    /* {
      path: './fonts/Garet-Heavy.woff2',
      weight: '850',
      style: 'normal'
    } */
  ]
})

export type ThemeProps = {
  fluid?: boolean
  theme?: {
    colors: {
      [key: string]: string
    }
  }
}

const hexToCSSvar = (hex?: string, defaultHex = '#fff') =>
  hexRgb((hex || defaultHex).split('#')[1], {
    format: 'array'
  })
    .slice(0, -1)
    .join(' ')

const Theme = ({ theme, fluid }: ThemeProps) => {
  const lastViewportWidth = useRef(0)

  const resize = useCallback(() => {
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (lastViewportWidth.current === viewportWidth) return
    lastViewportWidth.current = viewportWidth

    const vh = viewportHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [])

  useIsomorphicLayoutEffect(() => resize(), [resize])

  useEvent('resize', resize)

  return (
    <style jsx global>{`
      :root {
        --font-family-garet: ${garet.style.fontFamily};

        --font-size: ${fluid ? `max(${(10 / 1440) * 100}vw, 10px)` : '10px'};

        // --color-background: 216 231 243; // #d8e7f3
        // --color-foreground: 85 143 190; // #558fbe
        // --color-heading: 255 122 48; // #ff7a30
        // --color-mainbody: 15 66 107; // #0f426b

        // --color-background: 15 66 107; // #0f426b
        // --color-foreground: 255 255 255; // #ffffff
        // --color-heading: 255 122 48; // #ff7a30
        // --color-mainbody: 255 255 255; // #ffffff

        --color-background: ${hexToCSSvar(theme?.colors.background, '#d8e7f3')};
        --color-foreground: ${hexToCSSvar(theme?.colors.foreground, '#558fbe')};
        --color-heading: ${hexToCSSvar(theme?.colors.heading, '#ff7a30')};
        --color-mainbody: ${hexToCSSvar(theme?.colors.body, '#0f426b')};

        --color-primary: 125 59 237; // #7d3bed
        --color-secondary: 255 255 255; // #ffffff
      }
    `}</style>
  )
}

export default Theme
